import { LazoPaths } from "./LazoPaths";

export const EMAIL_REDIRECT_PATHS = [LazoPaths.TASK_DETAILS, LazoPaths.ONE_TASK_DETAILS];
